import useTimeout from './use-timeout';

export { useTimeout };

export default useTimeout;
